import { render } from "./zuzhijiagou.vue?vue&type=template&id=17aab47d&scoped=true&ts=true"
import script from "./zuzhijiagou.vue?vue&type=script&lang=ts"
export * from "./zuzhijiagou.vue?vue&type=script&lang=ts"

import "./zuzhijiagou.vue?vue&type=style&index=0&id=17aab47d&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17aab47d"]])

export default __exports__